import { getAllUsersAPI } from "../../apiRequests/user/getAllUsersAPI";
import { AppThunk, AppDispatch } from "../store";
import { setUsers, setIsLoading } from "./user-reducer";
import { UserDto } from "../../types/user.dto";

export const getAllUsersThunk = (): AppThunk => async (dispatch) => {
    try {
        dispatch(setIsLoading(true));
        const allUsers = await getAllUsersAPI();
        dispatch(setUsers(allUsers));
    } catch (error) {
        console.log(error);
    } finally {
        dispatch(setIsLoading(false));
    }
};
